import { PageId } from 'constants/pages'

export const enum PageIdWoofzS1612 {
  DOG_BREED_S1_6_12 = PageId.DOG_BREED_S1_6_12,
  DOG_AGE_S1_6_12 = PageId.DOG_AGE_S1_6_12,
  SHELTER_S1_6_12 = PageId.SHELTER_S1_6_12,
  COMMANDS_S1_6_12 = PageId.COMMANDS_S1_6_12,
  SUBSCRIPTIONS_S1_6_12 = PageId.SUBSCRIPTIONS_S1_6_12,
  CHAT_UPSELL_S1_6_12 = PageId.CHAT_UPSELL_S1_6_12,
  UPSELL_1_S1_6_12 = PageId.UPSELL_1_S1_6_12,
  DOWNLOAD_S1_6_12 = PageId.DOWNLOAD_S1_6_12,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
